import api from '@/services/api';

/**
 * Pobieranie obrazów, które leżą na prywatnym dysku i wychodzą przez kontroler
 * ze sprawdzeniem uprawnień.
 *
 * Przeglądarka nie dołoży nagłówka z tokenem do znacznika `img`, więc adres
 * kontrolera wstawiony wprost do `src` skończyłby się odmową. Pobieramy więc
 * zawartość żądaniem (z tokenem) i podmieniamy na adres blob — ten sam wzorzec,
 * którym baza wiedzy od dawna pokazuje swoje zrzuty.
 *
 * Adres blob jest z tego samego źródła co strona, więc kanwa edytora może z
 * niego korzystać bez `crossOrigin` — znika przy okazji blokada, przez którą
 * grafika potrafiła wyeksportować się bez nałożonej ramki.
 */

// Jeden adres blob na jeden adres źródłowy — miniatura w tabeli i podgląd
// w oknie modalnym nie pobierają tego samego pliku dwa razy.
const pamiec = new Map();

export function pobierzObraz(url) {
    if (!url) return Promise.resolve(null);

    if (!pamiec.has(url)) {
        pamiec.set(
            url,
            api.get(url.replace(/^\/api\/v1/, ''), { responseType: 'blob', skipErrorToast: true })
                .then(({ data }) => URL.createObjectURL(data))
                .catch((e) => { pamiec.delete(url); throw e; }),
        );
    }

    return pamiec.get(url);
}

/** Zwalnia wszystkie adresy blob — wołane przy wylogowaniu. */
export function zwolnijObrazy() {
    for (const obietnica of pamiec.values()) {
        // cichy-catch: zwalniamy to, co się udało pobrać. Odrzucona obietnica
        // nie zostawiła adresu, więc nie ma czego zwalniać ani zgłaszać.
        obietnica.then(URL.revokeObjectURL).catch(() => {});
    }
    pamiec.clear();
}
